// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_ce","pageSubTitle":"e_de"};